(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-bundle"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('brand-bundle-builder')) {
  customElements.define('brand-bundle-builder', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.controller = new AbortController();
      this.rows = [...this.querySelectorAll('[data-row]')];
      this.tiers = [...this.querySelectorAll('[data-tier]')];
      this.quantities = new Map(this.rows.map(row => [row, 0]));
      this.submit = this.querySelector('[data-submit]');
      this.submitLabel = this.submit.textContent;
      this.status = this.querySelector('[data-status]');
      this.formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:this.dataset.currency});
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || button.disabled || this.busy) return;
        const row = button.closest('[data-row]');
        if (row && (button.hasAttribute('data-add') || button.hasAttribute('data-plus') || button.hasAttribute('data-minus'))) {
          const delta = button.hasAttribute('data-minus') ? -1 : 1;
          this.quantities.set(row, Math.max(0, Math.min(99, this.quantities.get(row) + delta)));
          this.status.textContent = '';
          this.render();
          if (button.hidden || button.closest('[hidden]')) row.querySelector(this.quantities.get(row) ? '[data-minus]' : '[data-add]').focus();
        }
        if (button.hasAttribute('data-scroll')) this.querySelector('.bbb__list').scrollBy({top:260,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        if (button.hasAttribute('data-submit')) this.addBundle();
      }, {signal:this.controller.signal});
      this.render();
      const list = this.querySelector('.bbb__list');
      this.observer = new ResizeObserver(() => { this.querySelector('[data-scroll]').hidden = list.scrollHeight <= list.clientHeight + 2; });
      this.observer.observe(list);
      this.rows.forEach(row => this.observer.observe(row));
    }
    disconnectedCallback() { this.observer?.disconnect(); this.controller?.abort(); this.initialized = false; }
    money(cents) { return this.formatter.format(cents / 100); }
    render() {
      let count = 0, subtotal = 0;
      this.rows.forEach(row => {
        const quantity = this.quantities.get(row);
        count += quantity;
        subtotal += quantity * Number(row.dataset.price);
        row.querySelector('[data-add]').hidden = quantity > 0;
        row.querySelector('.bbb__quantity').hidden = quantity === 0;
        row.querySelector('[data-quantity]').textContent = quantity;
        row.querySelector('[data-plus]').disabled = quantity >= 99;
      });
      const active = Math.min(count, 4);
      const discount = active ? Number(this.tiers[active - 1].dataset.discount) : 0;
      const total = Math.round(subtotal * (100 - discount) / 100);
      const prices = this.rows.filter(row => row.dataset.id && !row.querySelector('[data-add]').disabled).map(row => Number(row.dataset.price));
      const equalPrices = prices.length && prices.every(price => price === prices[0]);
      this.tiers.forEach((tier, index) => {
        tier.classList.toggle('is-active', index + 1 === active);
        const rate = Number(tier.dataset.discount);
        tier.querySelector('[data-tier-price]').textContent = equalPrices ? this.money(Math.round(prices[0] * (100 - rate) / 100)) + this.dataset.unit : '';
        tier.querySelector('[data-tier-original]').textContent = equalPrices && rate > 0 ? this.money(prices[0] * (index + 1)) : '';
      });
      this.querySelector('[data-count]').textContent = count;
      this.querySelector('[data-total]').textContent = this.money(total);
      const original = this.querySelector('[data-original]');
      original.hidden = !discount || !count;
      original.textContent = this.money(subtotal);
      this.submit.disabled = !count || this.busy;
    }
    async addBundle() {
      const grouped = new Map();
      this.rows.forEach(row => {
        const quantity = this.quantities.get(row);
        if (quantity && row.dataset.id) grouped.set(row.dataset.id, (grouped.get(row.dataset.id) || 0) + quantity);
      });
      const items = [...grouped].map(([id, quantity]) => ({id, quantity}));
      if (!items.length) return;
      this.busy = true;
      this.submit.disabled = true;
      this.submit.textContent = this.dataset.loading;
      this.setAttribute('aria-busy', 'true');
      this.status.textContent = '';
      try {
        const response = await fetch(this.dataset.root + 'cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body:JSON.stringify({items})});
        const data = await response.json();
        if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : this.dataset.error);
        window.location.assign(this.dataset.cart);
      } catch (error) {
        this.status.textContent = error instanceof TypeError ? this.dataset.error : error.message;
        this.busy = false;
        this.removeAttribute('aria-busy');
        this.submit.textContent = this.submitLabel;
        this.render();
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
if (!customElements.get('tailva-uv-upsell')) {
  customElements.define('tailva-uv-upsell', class extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('button');
      this.button.addEventListener('click', () => this.toggle());
    }
    async toggle() {
      if (this.button.disabled) return;
      const selected = this.button.getAttribute('aria-checked') === 'true';
      const error = this.querySelector('[role="alert"]');
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      error.hidden = true;
      try {
        const sections = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {bubbles:true, detail:{sections}}));
        const root = this.dataset.root.replace(/\/$/, '') + '/';
        const response = await fetch(root + 'cart/update.js', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body:JSON.stringify({updates:{[this.dataset.variant]:selected ? 0 : 1}, sections, sections_url:location.pathname})
        });
        const cart = await response.json();
        if (!response.ok) throw new Error(cart.description || 'Unable to update cart. Please try again.');
        this.button.setAttribute('aria-checked', String(!selected));
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {bubbles:true, detail:{baseEvent:'variant:add', cart}}));
        setTimeout(() => document.querySelector('tailva-uv-upsell button')?.focus({preventScroll:true}), 100);
      } catch (err) {
        error.textContent = err.message;
        error.hidden = false;
        this.button.disabled = false;
        this.button.removeAttribute('aria-busy');
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daily-deals-bundle"] && !Shopify.designMode) return;
  try {
    
(function () {
function init(root) {
  if (!root || root.dataset.ddInit) return;
  root.dataset.ddInit = '1';

  var config = JSON.parse(root.querySelector('[data-dd-config]').textContent);
  var CLAIM_MIN = config.claimMin || 89, CLAIM_MAX = config.claimMax || 95;
  var REDIRECT = config.redirect, TXT_ITEMS = config.items, TXT_EMPTY = config.empty;
  var TXT_NEXT = config.next, TXT_ADDING = config.adding, TXT_CHECKOUT = config.checkout;
  var ROOT_URL = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var busy = false;
  var errorEl = root.querySelector('[data-dd-error]');
  function showError(err) {
    errorEl.textContent = (err && (err.description || err.message)) || 'Unable to add these products. Please check availability and try again.';
    errorEl.hidden = false;
  }
  function formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: config.currency}).format((Number(cents) || 0) / 100);
  }
  
  var timers = root.querySelectorAll('[data-timer]');
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tick() {
    var now = new Date(), end = new Date(now);
    end.setHours(24, 0, 0, 0);
    var d = Math.max(0, Math.floor((end - now) / 1000));
    var h = pad(Math.floor(d / 3600)), m = pad(Math.floor(d % 3600 / 60)), s = pad(d % 60);
    timers.forEach(function (t) {
      t.querySelector('[data-h]').textContent = h;
      t.querySelector('[data-m]').textContent = m;
      t.querySelector('[data-s]').textContent = s;
    });
  }
  var timerId;
  if (timers.length) { tick(); timerId = setInterval(tick, 1000); }

  
  var lo = Math.min(CLAIM_MIN, CLAIM_MAX), hi = Math.max(CLAIM_MIN, CLAIM_MAX);
  var claims = root.querySelectorAll('[data-claim]');
  function fillClaims() {
    claims.forEach(function (c) {
      var pct = Math.floor(Math.random() * (hi - lo + 1)) + lo;
      c.querySelector('[data-claim-pct]').textContent = pct;
      c.querySelector('.dd-claim__fill').style.width = pct + '%';
    });
  }
  if ('IntersectionObserver' in window) {
    claims.forEach(function (c) { c.querySelector('[data-claim-pct]').textContent = Math.floor(Math.random() * (hi - lo + 1)) + lo; });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.querySelector('.dd-claim__fill').style.width = e.target.querySelector('[data-claim-pct]').textContent + '%';
          io.unobserve(e.target);
        }
      });
    }, { threshold: .3 });
    claims.forEach(function (c) { io.observe(c); });
  } else { fillClaims(); }

  
  var chips = root.querySelectorAll('[data-filter]');
  var cards = root.querySelectorAll('[data-card]');
  chips.forEach(function (chip) {
    chip.addEventListener('click', function () {
      chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); c.setAttribute('aria-pressed', String(c === chip)); });
      var f = chip.dataset.filter;
      cards.forEach(function (card) {
        card.hidden = !(f === 'all' || card.dataset.tags.indexOf(',' + f + ',') > -1);
      });
      root.querySelector('[data-filter-empty]').hidden = Array.from(cards).some(function(card) { return !card.hidden; });
    });
  });

  
  var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-tier]')).map(function (el) {
    return { el: el, qty: parseInt(el.dataset.qty, 10) || 1, discount: parseFloat(el.dataset.discount) || 0, code: el.dataset.code || '' };
  }).sort(function (a, b) { return a.qty - b.qty; });
  tiers.forEach(function(t) { t.el.parentElement.appendChild(t.el); });
  var lineFill = root.querySelector('[data-line]');
  var track = root.querySelector('.dd-st__track');
  var stBox = root.querySelector('.dd-st__box');
  function placeTrack() {
    if (!track || tiers.length < 2) { if (track) track.style.display = 'none'; return; }
    var box = stBox.getBoundingClientRect();
    var a = tiers[0].el.querySelector('.dd-tier__dot').getBoundingClientRect();
    var b = tiers[tiers.length - 1].el.querySelector('.dd-tier__dot').getBoundingClientRect();
    track.style.left = (a.left + a.width / 2 - box.left) + 'px';
    track.style.width = (b.left + b.width / 2 - (a.left + a.width / 2)) + 'px';
    track.style.top = (a.top + a.height / 2 - box.top - 2) + 'px';
  }
  placeTrack();
  window.addEventListener('resize', placeTrack);
  var bar = root.querySelector('[data-bar]');
  var stickyProgress = bar && bar.querySelector('[data-bar-progress]');
  var stickySteps = [];
  if (stickyProgress && tiers.length) {
    stickyProgress.hidden = false;
    stickyProgress.style.setProperty('--steps', tiers.length);
    stickyProgress.style.setProperty('--edge', (50 / tiers.length) + '%');
    var stepsHost = stickyProgress.querySelector('[data-bar-steps]');
    stepsHost.replaceChildren();
    tiers.forEach(function(t) {
      var step = document.createElement('div');
      step.className = 'dd-bar-progress__step';
      var badge = document.createElement('b');
      badge.textContent = t.discount + '%';
      var dot = document.createElement('i');
      dot.setAttribute('aria-hidden', 'true');
      var label = document.createElement('span');
      label.textContent = t.el.querySelector('.dd-tier__label').textContent;
      step.append(badge, dot, label);
      stepsHost.appendChild(step);
      stickySteps.push(step);
    });
  }
  var bundle = {};

  function variantData(card) {
    var el = card.querySelector('[data-variant]');
    var opt = el.tagName === 'SELECT' ? el.options[el.selectedIndex] : el;
    return { id: el.value, price: parseInt(opt.dataset.price, 10) || 0, compare: parseInt(opt.dataset.compare, 10) || 0 };
  }

  function currentTier(count) {
    var t = null;
    tiers.forEach(function (x) { if (count >= x.qty) t = x; });
    return t;
  }

  function render() {
    var count = 0, sub = 0;
    Object.keys(bundle).forEach(function (id) { count += bundle[id].qty; sub += bundle[id].qty * bundle[id].price; });
    var tier = currentTier(count);
    var disc = tier ? tier.discount : 0;
    var total = Math.round(sub * (100 - disc) / 100);

    tiers.forEach(function (t, i) {
      t.el.classList.toggle('is-reached', count >= t.qty);
      t.el.classList.toggle('is-current', t === tier);
    });
    if (lineFill && tiers.length > 1) {
      var idx = tier ? tiers.indexOf(tier) : -1;
      var pct = idx <= 0 ? 0 : (idx / (tiers.length - 1)) * 100;
      if (idx >= 0 && idx < tiers.length - 1) {
        var next = tiers[idx + 1], span = next.qty - tier.qty;
        pct += ((count - tier.qty) / span) * (100 / (tiers.length - 1));
      }
      lineFill.style.width = Math.min(100, pct) + '%';
    }

    cards.forEach(function (card) {
      var v = variantData(card);
      var item = bundle[v.id];
      card.classList.toggle('is-selected', !!item);
      var q = card.querySelector('[data-qty]');
      if (q) q.textContent = item ? item.qty : 1;
    });

    if (!bar) return;
    if (stickyProgress) {
      stickyProgress.querySelector('[data-bar-fill]').style.width = (tiers.length > 1 ? Math.min(100, pct || 0) : 0) + '%';
      stickySteps.forEach(function(step, i) {
        step.classList.toggle('is-reached', count >= tiers[i].qty);
        step.classList.toggle('is-current', tiers[i] === tier);
      });
    }
    bar.querySelector('[data-bar-total]').textContent = formatMoney(total);
    var was = bar.querySelector('[data-bar-was]');
    if (total < sub) { was.hidden = false; was.textContent = formatMoney(sub); } else { was.hidden = true; }
    bar.querySelector('[data-checkout]').disabled = busy || count < (tiers[0] ? tiers[0].qty : 1);
  }

  cards.forEach(function (card) {
    var add = card.querySelector('[data-add]');
    var plus = card.querySelector('[data-plus]');
    var minus = card.querySelector('[data-minus]');
    var sel = card.querySelector('select[data-variant]');


    function updatePrices() {
      var v = variantData(card);
      var p = card.querySelector('[data-price]'), c = card.querySelector('[data-compare]');
      if (p) p.textContent = formatMoney(v.price);
      if (c) { c.hidden = !(v.compare > v.price); c.textContent = formatMoney(v.compare); }
      var s = card.querySelector('[data-save]');
      if (s) { var amt = v.compare - v.price; s.hidden = amt <= 0; s.querySelector('[data-save-amt]').textContent = formatMoney(amt); }
    }

    if (add) add.addEventListener('click', function () {
      if (busy || add.disabled) return;
      var v = variantData(card);
      bundle[v.id] = { qty: 1, price: v.price, compare: v.compare };
      render();
    });
    if (plus) plus.addEventListener('click', function () {
      if (busy) return;
      var v = variantData(card);
      if (bundle[v.id]) bundle[v.id].qty++;
      render();
    });
    if (minus) minus.addEventListener('click', function () {
      if (busy) return;
      var v = variantData(card);
      if (!bundle[v.id]) return;
      bundle[v.id].qty--;
      if (bundle[v.id].qty <= 0) delete bundle[v.id];
      render();
    });
    if (sel) sel.addEventListener('change', function () {
      var v = variantData(card);

      updatePrices();
      render();
    });
  });

  function addToCart(items) {
    return fetch(ROOT_URL + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  var checkoutBtn = root.querySelector('[data-checkout]');
  if (checkoutBtn) checkoutBtn.addEventListener('click', function () {
    if (busy || checkoutBtn.disabled) return;
    errorEl.hidden = true;
    var items = Object.keys(bundle).map(function (id) { return { id: parseInt(id, 10), quantity: bundle[id].qty }; });
    if (!items.length) return;
    var count = items.reduce(function (a, b) { return a + b.quantity; }, 0);
    var tier = currentTier(count);
    busy = true;
    checkoutBtn.disabled = true;
    checkoutBtn.textContent = TXT_ADDING;
    addToCart(items).then(function () {
      var dest = ROOT_URL + (REDIRECT === 'checkout' ? 'checkout' : 'cart');
      if (tier && tier.code) {
        window.location.href = ROOT_URL + 'discount/' + encodeURIComponent(tier.code) + '?redirect=' + encodeURIComponent(dest);
      } else {
        window.location.href = dest;
      }
    }).catch(function (err) {
      busy = false;
      showError(err);
      render();
      checkoutBtn.textContent = TXT_CHECKOUT;
    });
  });

  
  var feat = root.querySelector('[data-feat]');
  if (feat) {
    var main = feat.querySelector('[data-feat-main]');
    feat.querySelectorAll('[data-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        feat.querySelectorAll('[data-thumb]').forEach(function (x) { x.classList.toggle('is-active', x === b); });
        if (main) { main.removeAttribute('srcset'); main.src = b.dataset.thumb; }
      });
    });
  }

  render();
  root.ddCleanup = function() {
    clearInterval(timerId);
    window.removeEventListener('resize', placeTrack);
    if (typeof io !== 'undefined' && io) io.disconnect();
    delete root.dataset.ddInit;
  };
}
function mount(scope) { scope.querySelectorAll('[data-dd]').forEach(init); }
mount(document);
document.addEventListener('shopify:section:load', function(e) { mount(e.target); });
document.addEventListener('shopify:section:unload', function(e) {
  e.target.querySelectorAll('[data-dd]').forEach(function(root) { if (root.ddCleanup) root.ddCleanup(); });
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["scent-bundle-pdp"] && !Shopify.designMode) return;
  try {
    
(()=>{
function init(root){if(root.dataset.ready)return;root.dataset.ready='1';const cfg=JSON.parse(root.querySelector('[data-config]').textContent);const rows=[...root.querySelectorAll('[data-row]')];const quantities=new Map();let busy=false;const submit=root.querySelector('[data-submit]');const list=root.querySelector('.sb-list');const mobile=window.matchMedia('(max-width:899px)');const syncListFocus=()=>{if(mobile.matches)list.removeAttribute('tabindex');else list.setAttribute('tabindex','0');};syncListFocus();mobile.addEventListener('change',syncListFocus);const money=v=>new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:cfg.currency}).format(v/100);
function update(){let count=0,eligible=0;for(const row of rows){const q=quantities.get(row.dataset.id)||0;count+=q;if(row.dataset.eligible==='true')eligible+=q;row.querySelector('[data-quantity]').textContent=q;row.querySelector('[data-add]').hidden=q>0;row.querySelector('.sb-stepper').hidden=!q;row.classList.toggle('selected',q>0);}
const discount=eligible>=4?30:eligible>=3?20:eligible>=2?10:0;let total=0,original=0;for(const row of rows){const q=quantities.get(row.dataset.id)||0;original+=Number(row.dataset.compare||row.dataset.price)*q;total+=Math.round(Number(row.dataset.price)*(row.dataset.eligible==='true'?1-discount/100:1))*q;}root.querySelector('[data-summary]').textContent=count===1?cfg.oneBottle:count?cfg.summary.replace('[count]',count).replace('[discount]',discount):cfg.empty;root.querySelector('[data-total]').textContent=count?money(total):'';submit.disabled=busy||!count;submit.classList.toggle('is-empty',!count);submit.querySelector('.sb-submit-arrow').toggleAttribute('hidden',!count||busy);if(busy)submit.setAttribute('aria-busy','true');else submit.removeAttribute('aria-busy');submit.querySelector('[data-submit-label]').textContent=busy?cfg.adding:count?cfg.addToCart:cfg.selectBottle;submit.querySelector('[data-submit-prices]').hidden=!count||busy;submit.querySelector('[data-submit-original]').hidden=original<=total;submit.querySelector('[data-submit-original]').textContent=money(original);submit.querySelector('[data-submit-total]').textContent=money(total);const progress=root.querySelector('[data-progress]');if(progress)progress.style.width=Math.max(0,Math.min(100,(eligible-1)/3*100))+'%';root.querySelectorAll('[data-tier]').forEach(t=>{const n=Number(t.dataset.tier);t.classList.toggle('reached',eligible>=n);t.classList.toggle('active',eligible>0&&n===Math.min(eligible,4));});}
root.addEventListener('click',async event=>{const button=event.target.closest('button');if(!button||!root.contains(button))return;if(button.dataset.image){const main=root.querySelector('img.sb-main');if(main){main.removeAttribute('srcset');main.src=button.dataset.image;main.alt=button.dataset.alt;}root.querySelectorAll('[data-image]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));return;}if(busy)return;const row=button.closest('[data-row]');if(row){const id=row.dataset.id;const q=quantities.get(id)||0;if(button.matches('[data-add],[data-plus]'))quantities.set(id,q+1);if(button.matches('[data-minus]'))quantities.set(id,Math.max(0,q-1));update();return;}if(button!==submit)return;const items=[...quantities].filter(([,q])=>q>0).map(([id,quantity])=>({id:Number(id),quantity}));if(!items.length)return;busy=true;update();const error=root.querySelector('[data-error]');error.hidden=true;const base=window.Shopify?.routes?.root||'/';const sections=['variant-added'];document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections}}));try{const response=await fetch(base+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:[...new Set(sections)],sections_url:base+'variants/'+items[0].id})});const data=await response.json();if(!response.ok)throw new Error(typeof data.description==='string'?data.description:cfg.error);// Follow Impact's native product-form lifecycle for the existing drawer.
try{const cartResponse=await fetch(base+'cart.js');if(!cartResponse.ok)throw new Error('Cart refresh failed');const cart=await cartResponse.json();cart.sections=data.sections;
const drawer=document.querySelector('cart-drawer');if(!drawer||Object.values(data.sections||{}).some(section=>section===null)){window.location.assign(base+'cart');return;}
root.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:data.items||[data],cart}}));document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'variant:add',cart}}));if(window.themeVariables?.settings?.cartType!=='drawer'&&typeof drawer.show==='function')drawer.show();
}catch(refreshError){window.location.assign(base+'cart');return;}busy=false;update();}catch(e){error.textContent=e.message||cfg.error;error.hidden=false;busy=false;update();}});update();}
function boot(scope){scope.querySelectorAll('[data-scent-bundle]').forEach(init);}boot(document);document.addEventListener('shopify:section:load',e=>boot(e.target));})();

  } catch(e) { console.error(e); }
})();
})();
